import { useIsEligibleForAddPaymentMethodFlowExperiment, useSelectedPaymentMethod } from '../../state'

export const useIsMissingPaymentMethod = (): boolean => {
  const isAddPaymentMethodFlowExperiment = useIsEligibleForAddPaymentMethodFlowExperiment()
  const initialSelectedPaymentMethod = useSelectedPaymentMethod()

  return isAddPaymentMethodFlowExperiment && !initialSelectedPaymentMethod
}
